import React, { useEffect, useRef, useState } from 'react';
import HeroEditProfile from '../../../components/hero/HeroEditProfile';
import useDocumentTitle from '../../../components/useDocumentTitle';
import useFullPageLoader from '../../../hooks/useFullPageLoader';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { ToastContainer, toast } from 'react-toastify';

import { Link, useNavigate } from 'react-router-dom';
import { UserUpdate, getUserByAddress } from '../../../hooks/User';
import { client } from '../../../config/ipfsConfig';
import { FiCamera, FiEdit, FiTrash2 } from 'react-icons/fi';
import defaultProfilePhoto from "../../../assets/img/avatars/defaultProfile.png"

const EditProfile = () => {
  const confirm = () => toast.success('Your email verified');
  const ref = useRef();
  const closeTooltip = () => ref.current.close();
  useDocumentTitle('Edit Profile');

  const Navigate = useNavigate();
  const [user, setUser] = useState({});
  const [formInput, updateFormInput] = useState({});
  const [facebook, setFacebook] = useState(null);
  const [twitter, setTwitter] = useState(null);
  const [discord, setDiscord] = useState(null);
  const [errors, setErrors] = useState({});
  const walletAddress = localStorage.getItem('WalletAddress');
  const [hasProfilePicture, setHasProfilePicture] = useState(false);

  const defaultProfilePhoto = "https://ipfs.infura.io/ipfs/QmQWX3qehN6pgmDx7n8dWf3EfdUP1iD1XGpmfMn338cAHq"; // Your new default image URL

  useEffect(() => {
    getUser();
  }, [walletAddress]);

  const getUser = () => {
    getUserByAddress(walletAddress).then((data) => {
      if (data.status === 200) {
        setUser(data.user);
        updateFormInput({
          name: data.user.name,
          username: data.user.username,
          bio: data.user.bio,
          email: data.user.email,
        });
      }
    });
  };

  
  async function handleData(e) {
    updateFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
  }


  const [showOptions, setShowOptions] = useState(false); // Manage visibility of options
  const optionsRef = useRef(null);




  // Close options when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Check if the user has a profile picture
    if (user?.profilePicture && user.profilePicture.length > 0) {
      setHasProfilePicture(true);
    } else {
      setHasProfilePicture(false);
    }
  }, [user]);

  const handleOptionsClick = () => {
    setShowOptions(!showOptions); // Toggle options menu visibility
  };

  const handleRemoveProfile = async () => {
    try {

      const newProfilePicURL = "https://ipfs.infura.io/ipfs/QmQWX3qehN6pgmDx7n8dWf3EfdUP1iD1XGpmfMn338cAHq"; // Your new image URL
      const updateBody = { profilePicture: newProfilePicURL };

      console.log("updateBody", updateBody);

      const updateResponse = await UserUpdate(updateBody, user._id);
      if (updateResponse.status === 200) {
        toast.success("Profile picture replaced successfully!");
        getUser(); // Refresh user data to reflect the change
        setHasProfilePicture(true); // Update the state
      } else {
        toast.error("Failed to update profile picture.");
      }

    } catch (error) {
      toast.error('Error updating profile picture.');
      console.error('Error:', error);
    }
  };

  const handleChange1 = async (e, type) => {
    const file = e.target.files[0]; // Get the selected file
    if (!file) {
      toast.error("No file selected!");
      return;
    }

    try {
      // Upload the file to IPFS
      const added = await client.add(file);
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;

      if (user) {
        // Dynamically set the property based on the type
        const body = {
          [type === 'profile' ? 'profilePicture' : 'coverPicture']: url,
        };

        // Call the API to update the user
        const response = await UserUpdate(body, user._id);
        if (response.status === 200) {
          getUser(); // Refresh user data
          toast.success(
            type === 'profile'
              ? 'Profile Picture updated successfully!'
              : 'Cover Picture updated successfully!'
          );
          setHasProfilePicture(true); // Update state to reflect the new profile picture
        } else {
          toast.error("Failed to update picture!");
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error('Error uploading file: ' + error.message);
    }
  };

  const triggerFileInput = () => {
    document.getElementById('profileImageUpload').click(); // Trigger the file input click
  };






  // const validateUsername = (username) => {
  //   const usernameStr = username || '';
  //   const usernameRegex = /^[a-zA-Z0-9_-]{5,20}$/;

  //   if (!usernameRegex.test(usernameStr)) {
  //     return 'Username must be between 5-20 characters and contain only letters, numbers, underscores, or hyphens.';
  //   }

  //   if (usernameStr.includes(' ')) {
  //     return 'Spaces are not allowed in the username.';
  //     toast.error('Error uploading file: ' + error.message);
  //   }
  // }


  const validateUsername = (username) => {
    const usernameStr = username || '';
    const usernameRegex = /^[a-zA-Z0-9_-]{5,20}$/;

    if (!usernameRegex.test(usernameStr)) {
      return 'Username must be between 5-20 characters and contain only letters, numbers, underscores, or hyphens.';
    }

    if (usernameStr.includes(' ')) {
      return 'Spaces are not allowed in the username.';
    }

    if (usernameStr.startsWith('_') || usernameStr.startsWith('-')) {
      return 'Username cannot start with an underscore or hyphen.';
    }

    if (usernameStr.endsWith('_') || usernameStr.endsWith('-')) {
      return 'Username cannot end with an underscore or hyphen.';
    }

    if (usernameStr.includes('__') || usernameStr.includes('--')) {
      return 'Username cannot contain consecutive underscores or hyphens.';
    }

    return null;
  };

  // const checkUsernameUniqueness = async (username) => {
  //   try {
  //     const response = await fetch(/api/check-username?username=${username});
  //     const data = await response.json();

  //     if (response.status === 200 && data.isAvailable) {
  //       return null; // Username is available
  //     } else {
  //       return 'This username is already taken. Please try another.';
  //     }
  //   } catch (error) {
  //     console.error('Error checking username uniqueness:', error);
  //     return 'An error occurred while checking the username. Please try again later.';
  //   }
  // };

  const register = async () => {
    const newErrors = {};
    const usernameError = validateUsername(formInput.username || '');
    if (usernameError) {
      newErrors.username = usernameError;
    }

    // const uniquenessError = await checkUsernameUniqueness(formInput.username || '');
    // if (uniquenessError) {
    //   newErrors.username = uniquenessError;
    // }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const body = {
      name: formInput.name || user?.name,
      username: formInput.username || user?.username,
      bio: formInput.bio || user?.bio,
      email: formInput.email || user?.email,
      socials: [
        facebook || user?.facebook,
        twitter || user?.twitter,
        discord || user?.discord,
      ],
    };

    UserUpdate(body, user._id).then((data) => {
      if (data.status === 200) {
        toast.success('User updated successfully!');
        setTimeout(() => {
          Navigate('/profile');
        }, 2000);
      } else {
        toast.error('Failed to update user profile.');
      }
    });
  };



  return (
    <div className="edit_profile">
      <HeroEditProfile

        tProfile user={user} />
      <div className="container">
        <div>
          <div className="avatars space-x-20 mb-30">
            <div id="profile-container">
              <img
                id="profileImage"
                src={hasProfilePicture ? user.profilePicture : "img/avatars/avatar_3.png"}
                alt="Avatar"
                className="avatar avatar-lg border-0"
              />
            </div>

            <div className="space-x-10 d-flex">
              <div id="boxUploadProfile" style={{ position: 'relative' }}>
                {/* Camera Icon */}
                <div
                  onClick={handleOptionsClick}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    borderRadius: '50%',
                    height: '40px',
                    width: '40px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'inline-block',
                    color: 'white',
                  }}
                >
                  <FiCamera
                    size={20}
                    style={{
                      position: 'absolute',
                      top: '43%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                    }}
                  />
                </div>

                <input
                  id="profileImageUpload"
                  type="file"
                  name="profile_photo"
                  style={{ display: 'none' }}
                  accept="image/*"
                  onChange={(e) => handleChange1(e, 'profile')}
                />

                {/* Options Menu */}
                {showOptions && hasProfilePicture && (
                  <div
                    ref={optionsRef}
                    style={{
                      position: 'absolute',
                      top: '-10px',
                      right: '0',
                      left: '30px',
                      padding: '10px',
                      borderRadius: '5px',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    {/* Edit Option */}
                    <div
                      onClick={triggerFileInput}
                      style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        margin: '0 10px',
                        height: '40px',
                        width: '40px',
                        padding: '10px',
                        borderRadius: '50%',
                        cursor: 'pointer',
                      }}
                    >
                      <FiEdit size={20} />
                    </div>

                    {/* Delete Option */}
                    <div
                      onClick={handleRemoveProfile}
                      style={{
                        backgroundColor: '#dc3545',
                        color: 'white',
                        height: '40px',
                        width: '40px',
                        padding: '10px',
                        borderRadius: '50%',
                        cursor: 'pointer',
                      }}
                    >
                      <FiTrash2 size={20} />
                    </div>
                  </div>
                )}

                {/* If no profile picture, just show the upload option */}
                {!hasProfilePicture && showOptions && (
                  <div
                    ref={optionsRef}
                    style={{
                      position: 'absolute',
                      top: '-10px',
                      right: '0',
                      left: '30px',
                      padding: '10px',
                      borderRadius: '5px',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div
                      onClick={triggerFileInput}
                      style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        margin: '0 10px',
                        height: '40px',
                        width: '40px',
                        padding: '10px',
                        borderRadius: '50%',
                        cursor: 'pointer',
                      }}
                    >
                      <FiEdit size={20} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>


          <div className="box edit_box col-lg-9 space-y-30">
            <div className="row sm:space-y-20">
              <div className="col-lg-6 account-info">
                <h3 className="mb-20">Account info 🍉</h3>
                <div className="form-group space-y-10 mb-0">
                  <div className="space-y-40">
                    <div className="space-y-10">
                      <span className="nameInput">Display name</span>
                      <input
                        id="txtUsername"
                        type="text"
                        name="username"
                        className="form-control"
                        onChange={(e) => handleData(e)}
                        value={formInput.username || user?.username}
                      />
                      {errors.username && <span className="error">{errors.username}</span>}
                      {errors.username && <span className="error">{errors.username}</span>}
                    </div>
                    <div className="space-y-10">
                      <span className="nameInput">Name</span>
                      <input
                        id="txtUsername"
                        type="text"
                        name="name"
                        className="form-control"
                        onChange={(e) => handleData(e)}
                        defaultValue={user ? user.name : "Name"}
                      />
                    </div>
                    <div className="space-y-10">
                      <span className="nameInput d-flex justify-content-between">
                        Email
                        <span className="txt_xs">
                          Your email for marketplace notifications
                        </span>
                      </span>
                      <div className="confirm">
                        <input
                          id="txtEmail"
                          type="text"
                          className="form-control"
                          name="email"
                          placeholder="Enter
                                      your email"
                          onChange={(e) => handleData(e)}
                          defaultValue={user ? user.email : "Update Your Email"}
                        />
                        <Link
                          to="#"
                          className="confirm-btn btn btn-dark btn-sm"
                          onClick={confirm}>
                          Confirm
                        </Link>
                      </div>
                    </div>
                    <div className="space-y-10">
                      <span className="nameInput">Bio</span>
                      <textarea
                        style={{ minHeight: 110 }}
                        onChange={(e) => handleData(e)}
                        name="bio"
                        placeholder="Add your bio"
                        defaultValue={user ? user.bio : "Add your Bio"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 social-media">
                <h3 className="mb-20">Your Social media</h3>
                <div className="form-group space-y-10">
                  <div className="space-y-40">
                    <div className="d-flex flex-column">
                      <span className="nameInput mb-10">Facebook</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="facebook username"
                        onChange={(e) => setFacebook(e.target.value)}
                      />
                      <Link
                        className="facebook-btn btn btn-primary mt-20 btn-sm"
                        to="#">
                        <i className="ri-facebook-circle-fill" />
                        Connect to Facebook
                      </Link>
                    </div>
                    <div className="d-flex flex-column">
                      <span className="nameInput mb-10">Twitter</span>
                      <input
                        type="text"
                        className="form-control"

                        placeholder="twitter username"
                        onChange={(e) => setTwitter(e.target.value)}
                      />
                      <Link
                        className="twitter-btn btn btn-primary mt-20 btn-sm"
                        to="#">
                        <i className="ri-twitter-fill" />
                        Connect to Twitter
                      </Link>
                    </div>
                    <div className="d-flex flex-column">
                      <span className="nameInput mb-10">Discord</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="discord username"
                        onChange={(e) => setDiscord(e.target.value)}
                      />
                      <Link
                        className="discord-btn btn btn-primary mt-20 btn-sm"
                        to="#">
                        <i className="ri-discord-fill" />
                        Connect to Discord
                      </Link>
                    </div>
                  </div>
                </div>

                <Popup
                  className="custom"
                  ref={ref}
                  trigger={
                    <button className="btn btn-white mt-20 btn-sm">
                      <i className="ri-add-circle-line color_brand mt-5px" />
                      Add more Social media
                    </button>
                  }
                  position="bottom center">
                  <div>
                    <div
                      className="popup"
                      id="popup_bid"
                      tabIndex={-1}
                      role="dialog"
                      aria-hidden="true">
                      <div>
                        <button
                          type="button"
                          className="button close"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={closeTooltip}>
                          <span aria-hidden="true">×</span>
                        </button>
                        <div className="space-y-20">
                          <h3 className="text-center">Add more Social media</h3>
                          <div className="d-flex flex-column">
                            <span className="nameInput mb-10">Telegram</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="telegram username"
                            />
                            <Link
                              className="telegram-btn btn btn-primary mt-20
      btn-sm"
                              to="#">
                              <i className="ri-telegram-fill mr-5px" />
                              Connect to Telegram
                            </Link>
                          </div>

                          <div className="d-flex flex-column">
                            <span className="nameInput mb-10">TikTok</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="tiktok username"
                            />
                            <Link
                              className="tiktok-btn btn btn-primary mt-20
      btn-sm"
                              to="#">
                              <img
                                className="mr-5px"
                                src={`img/icons/tiktok.svg`}
                                alt="tiktok"
                                style={{ height: 20 }}
                              />
                              Connect to TikTok
                            </Link>
                          </div>
                          <div className="d-flex flex-column">
                            <span className="nameInput mb-10">Youtube</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="youtube username"
                            />
                            <Link
                              className="youtube-btn btn btn-primary mt-20
      btn-sm"
                              to="#">
                              <i className="ri-youtube-fill mr-5px" />
                              Connect to Youtube
                            </Link>
                          </div>
                          <div className="d-flex flex-column">
                            <span className="nameInput mb-10">Medium</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="medium username"
                            />
                            <Link
                              className="medium-btn btn btn-primary mt-20
      btn-sm"
                              to="#">
                              <img
                                className="mr-5px"
                                src={`img/icons/medium.svg`}
                                alt="tiktok"
                                style={{ height: 21 }}
                              />
                              Connect to Medium
                            </Link>
                          </div>
                          <Link
                            className="discord-btn btn btn-primary
    w-100"
                            to="#">
                            Save
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Popup>
              </div>
            </div>
            <div className="hr" />
            <p className="color_black">
              To update your settings you should sign message through your
              wallet. Click 'Update profile' then sign the message.
            </p>
            <div>
              <Link to="#" className="btn btn-grad" onClick={register}>
                Update Profile
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
      {/* {loader} */}
    </div>
  );
};

export default EditProfile;